import {
  useEffect,
  useState
} from 'react';

import './App.scss';

import {
  Button,
  Dialog,
  DialogPanel,
  DialogTitle,
} from '@headlessui/react';

import {
  Outlet,
} from "react-router-dom";

import packageJson from '../package.json';


function Main() {

  const defaultTitle = 'LE CLUB - LACOSTE';

  const [loadingDialog, setLoadingDialog] = useState<string | null>(null);
  const [errorDialog, setErrorDialog] = useState<string | null>(null);

  const [currentTitle, setCurrentTitle] = useState<string>(defaultTitle);

  useEffect(
    () => {
      setCurrentTitle(defaultTitle);
      // switch (window.location.pathname) {
      //   case '/':
      //     setCurrentTitle('Progress');
      //     break;
      //   default:
      //     setCurrentTitle(defaultTitle);
      // }
    },
    [window.location.pathname]
  );

  return (
    <>
      <Outlet />
      <div className="fixed inset-0 w-full py-2 px-5text-left h-14 inline-flex text-end">
        <div className='flex-1 flex-end px-3 text-xs text-zinc-200'>
          Version {packageJson.version}
        </div>
      </div>

      <Dialog open={loadingDialog ? true : false}
        onClose={() => { }}
        className="relative z-10 focus:outline-none" as="div"
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className="w-auto max-w-md bg-white/60 p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0 shadow-xl border border-black/20 text-center"
            >
              <p className="text-sm/6 text-black/50">
                {loadingDialog}
              </p>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <Dialog open={errorDialog ? true : false}
        onClose={() => setErrorDialog(null)}
        className="relative z-10 focus:outline-none" as="div"
      >
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <DialogPanel
              transition
              className="w-full max-w-md bg-white/60 p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0 shadow-xl border border-black/20"
            >
              <DialogTitle as="h3" className="text-base/7 font-medium text-red">
                Error
              </DialogTitle>
              <p className="mt-2 text-sm/6 text-black/50">
                {errorDialog}
              </p>
              <div className="mt-4">
                <Button
                  className="inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[focus]:outline-1 data-[focus]:outline-white data-[open]:bg-gray-700 "
                  onClick={
                    () => {
                      setErrorDialog(null);
                    }
                  }
                >
                  Close
                </Button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

    </>
  );
}

export default Main;